<template>
  <div class="component-body">
    <el-pagination
        background
        layout="prev, pager, next"
        :total="1000">
    </el-pagination>
    <el-pagination
        class="margin-top-35"
        :page-size="20"
        :pager-count="11"
        layout="prev, pager, next"
        :total="1000">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/19/Pagination/index.vue